var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { title: "" + _vm.title, "hide-footer": "", centered: "" },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _vm.isEdit
        ? _c("EditFileForm", { attrs: { title: _vm.title } })
        : _c("NewFilesForm", { attrs: { title: _vm.title } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }